<template>
  <div id="EditCertification" class="wrap">
    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Edit Certification</span>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-card class=" mb-5 pt-5" flat  >
          <v-layout column align-center class="justify-center hidden-sm-and-down mb-3">
            <span class="title light-blue--text text--darken-3 text-center">Edit Certification</span>
          </v-layout>
            <v-card-text class="mt-0 pt-0 px-0">
              <!-- Healthcare Experience Info Container-->
              <v-container  grid-list-md pt-0 px-1>
                <v-form  >
                  <!-- Experience Type-->
                  <v-flex xs12>
                    <v-select
                      v-model="certificationInfo.certification_type"
                      :items="['BLS','CPR','ACLS',]"
                      label="Certification"
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>

                    <!--Start Date  -->
                    <v-flex xs12>
                      <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        v-model="menu2"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          slot="activator"
                          :value="computedCompletionDateFormattedMomentjs"
                          label="Completion Date"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          clearable
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="certificationInfo.completion_date" no-title @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <!--End Date  -->
                    <v-flex xs12>
                      <v-menu
                        ref="menu3"
                        :close-on-content-click="false"
                        v-model="menu3"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                          slot="activator"
                          :value="computedExpDateFormattedMomentjs"
                          label="Expiration Date"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          clearable
                          readonly
                          v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="certificationInfo.expiration_date" no-title @input="$refs.menu3.save(certificationInfo.expiration_date)"></v-date-picker>

                      </v-menu>
                    </v-flex>

                </v-form>

                <v-layout row class="mt-2 mb-3">
                  <v-btn
                    @click="editCertification"
                    color="green"
                    dark
                    large
                    block
                    depressed
                    >
                    Save
                  </v-btn>
                </v-layout>

              </v-container>

            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="red" flat @click.native="AddExperienceDialog = false">Close</v-btn>
            <v-btn color="green"  flat @click.native="addExperience()">Save</v-btn> -->
          </v-card-actions>

        </v-card>
      </div>
    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>
</template>

<script>
  import moment from 'moment'
export default {
  data() {
    return {
      menu2: false,
      menu3: false,
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    backDesktop  () {
      this.$router.push('/dashboard')
    },
    editCertification() {
      const certificationData = {
        certification_type : this.certificationInfo.certification_type,
        completion_date: this.certificationInfo.completion_date,
        expiration_date: this.certificationInfo.expiration_date,
        certificationId: this.id,
      }
      this.$store.dispatch('setEditCertification', certificationData)
      this.$router.go(-1);
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    certificationInfo() {
      return this.$store.getters.certificationInfo(this.id)
    },
    computedCompletionDateFormattedMomentjs() {
        return this.certificationInfo.completion_date ? moment(this.certificationInfo.completion_date).format('MM/DD/YYYY') : ''
      },
      computedExpDateFormattedMomentjs () {
        return this.certificationInfo.expiration_date ? moment(this.certificationInfo.expiration_date).format('MM/DD/YYYY') : ''
      },
  }
}
</script>

<style scoped>
  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/Certifications/EditCertification.vue